import ResendEmailsModal from './ResendEmailsModal.container'

export default ResendEmailsModal
